export const SIGN_IN = 'SIGN_IN';
export const PUBLIC_SIGN_IN = 'PUBLIC_SIGN_IN';
export const SET_AUTH = 'SET_AUTH';
export const SET_SHARE_TOKEN = 'SET_SHARE_TOKEN';
export const SERVER_ERROR = 'SERVER_ERROR';
export const CREATE_SHARE_TOKEN = 'CREATE_SHARE_TOKEN'
export const GET_DS_PERMISSIONS = 'GET_DS_PERMISSIONS'
export const SET_DS_PERMISSIONS = 'SET_DS_PERMISSIONS'
